var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3543 13.7969H1.63011C1.29028 13.7969 1.01562 13.5526 1.01562 13.2504V4.3277C1.01562 4.0255 1.29028 3.78125 1.63011 3.78125H14.3543C14.6941 3.78125 14.9688 4.0255 14.9688 4.3277V13.2504C14.9688 13.5512 14.6925 13.7969 14.3543 13.7969Z",
    fill: "#FFE9B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.42188H1.01562V3.28703C1.01562 2.94683 1.29059 2.67188 1.6308 2.67188H6.4108C6.68267 2.67188 6.92189 2.84897 6.99956 3.10994L8 6.42188Z",
    fill: "#FFB02C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3543 13.7969H1.63011C1.29028 13.7969 1.01562 13.5222 1.01562 13.1823V5.23956C1.01562 4.89969 1.29028 4.625 1.63011 4.625H14.3543C14.6941 4.625 14.9688 4.89969 14.9688 5.23956V13.1823C14.9688 13.5206 14.6925 13.7969 14.3543 13.7969Z",
    fill: "#FFCA28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.6fbfbb21777213b21e87ea5bea7a2591.svg";
export { ForwardRef as ReactComponent };